import { Box, CircularProgress } from '@mui/material';
import React from 'react';

export const TranslationLoader = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#111',
    }}
  >
    <Box
      sx={{
        textAlign: 'center',
      }}
    >
      <CircularProgress size={40} thickness={4} />
    </Box>
  </Box>
);
